import { render, staticRenderFns } from "./CredentialsModal.vue?vue&type=template&id=843919c6&scoped=true"
import script from "./CredentialsModal.vue?vue&type=script&lang=js"
export * from "./CredentialsModal.vue?vue&type=script&lang=js"
import style0 from "./CredentialsModal.vue?vue&type=style&index=0&id=843919c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843919c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843919c6')) {
      api.createRecord('843919c6', component.options)
    } else {
      api.reload('843919c6', component.options)
    }
    module.hot.accept("./CredentialsModal.vue?vue&type=template&id=843919c6&scoped=true", function () {
      api.rerender('843919c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/CredentialsModal.vue"
export default component.exports